// extracted by mini-css-extract-plugin
export default {"root":"FormElement_root__XfC7o"};